import _extends from 'babel-runtime/helpers/extends';
import _objectWithoutProperties from 'babel-runtime/helpers/objectWithoutProperties';
import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
/* eslint-disable no-underscore-dangle */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { makeOutfitParser, category } from '../outfit-parser';
import outfitPropValidator from '../outfitPropValidator';
import { getAllowedAttributes } from '../props-filters';

import * as style from './TitleHeader.style';
import propTypeClassName from '../propTypeClassName';

var modifiersList = ['stretched'];

var parseOutfit = makeOutfitParser(category('modifiers', modifiersList));

var TitleHeader = function (_PureComponent) {
  _inherits(TitleHeader, _PureComponent);

  function TitleHeader() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TitleHeader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TitleHeader.__proto__ || _Object$getPrototypeOf(TitleHeader)).call.apply(_ref, [this].concat(args))), _this), _this.titleHeaderContentFirst = _this.props.titleHeaderContent, _this.titleHeaderContentSecond = _this.props.titleHeaderContent, _this.titleHeaderContentCurrent = 1, _this.titleHeaderContentFirstRef = null, _this.titleHeaderContentSecondRef = null, _this._getRefFirst = function (ref) {
      _this.titleHeaderContentFirstRef = ref;
    }, _this._getRefSecond = function (ref) {
      _this.titleHeaderContentSecondRef = ref;
    }, _this._animationInOut = function (titleHeaderContent) {
      if (_this.titleHeaderContentCurrent === 1) _this._handleSwitchFrom1to2(titleHeaderContent);else if (_this.titleHeaderContentCurrent === 2) _this._handleSwitchFrom2to1(titleHeaderContent);
    }, _this._handleSwitchFrom1to2 = function (titleHeaderContent) {
      _this.titleHeaderContentSecond = titleHeaderContent;
      _this.titleHeaderContentCurrent = 2;
      _this.titleHeaderContentFirstRef.classList.add(style.fadeOut);
      _this.titleHeaderContentSecondRef.classList.remove(style.fadeOut);
    }, _this._handleSwitchFrom2to1 = function (titleHeaderContent) {
      _this.titleHeaderContentFirst = titleHeaderContent;
      _this.titleHeaderContentCurrent = 1;
      _this.titleHeaderContentFirstRef.classList.remove(style.fadeOut);
      _this.titleHeaderContentSecondRef.classList.add(style.fadeOut);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TitleHeader, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref2) {
      var titleHeaderContent = _ref2.titleHeaderContent;

      if (titleHeaderContent && this.props.titleHeaderContent !== titleHeaderContent) {
        this._animationInOut(titleHeaderContent);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          outfit = _props.outfit,
          actionSlot = _props.actionSlot,
          className = _props.className,
          restProps = _objectWithoutProperties(_props, ['outfit', 'actionSlot', 'className']);

      var titleHeader = style.titleHeader,
          titleHeaderContainer = style.titleHeaderContainer,
          titleHeaderContent = style.titleHeaderContent,
          actionSlotContainer = style.actionSlotContainer,
          actionSlotContent = style.actionSlotContent,
          fadeOut = style.fadeOut;


      var parsedOutfit = parseOutfit(outfit);
      var stretched = parsedOutfit.get('modifiers').has('stretched');
      var allowedAttributes = getAllowedAttributes(restProps);
      var hasIndentation = !!actionSlot;

      return React.createElement(
        'div',
        _extends({ className: cx(titleHeader(stretched), className) }, allowedAttributes),
        React.createElement(
          'div',
          { className: titleHeaderContainer(hasIndentation) },
          React.createElement(
            'div',
            { ref: this._getRefFirst, className: titleHeaderContent },
            this.titleHeaderContentFirst
          ),
          React.createElement(
            'div',
            { ref: this._getRefSecond, className: cx(titleHeaderContent, fadeOut) },
            this.titleHeaderContentSecond
          )
        ),
        actionSlot && React.createElement(
          'div',
          { className: actionSlotContainer },
          React.createElement(
            'div',
            { className: actionSlotContent },
            actionSlot
          )
        )
      );
    }
  }]);

  return TitleHeader;
}(PureComponent);

TitleHeader.propTypes = {
  /**
   * Type: **string**.
   *
   * @see See [Commonly used attributes](#components-common-props) for a detailed description.
   *
   * Options:
   *
   *    - Modifier:
   *      - "**stretched**" (have height 100%)
   */
  outfit: outfitPropValidator(modifiersList),
  /** Content to be displayed inside the title header */
  titleHeaderContent: PropTypes.node,
  /** Content to be displayed on the right side of the title header */
  actionSlot: PropTypes.node,
  /**
   * Type: **string**.
   *
   * @see See [Commonly used attributes](#components-common-props) for a detailed description.
   */
  className: propTypeClassName
};
export default TitleHeader;